var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "polygon2989_00000091712160093483359120000013545222466388029605_",
    d: "m437.367 100.62-33.046 370.199-148.543 41.181-148.134-41.123-33.011-370.257z",
    fill: "#004ce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2991_00000130636505511401349330000011479272249651210121_",
    d: "m376.03 447.246 28.24-316.352h-148.27v349.629z",
    fill: "#0065f4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2993_00000027586116533142052040000014804943466300760462_",
    d: "m150.31 268.217 4.07 45.41h101.62l19.533-22.705-19.533-22.705z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2995_00000098936504455534668280000009583779879621411251_",
    d: "m256 176.305h-.157-113.711l4.128 45.411h109.74l19.533-22.706z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2997_00000011734588395863960860000002272664363377641402_",
    d: "m256 433.399 19.533-24.081-19.533-23.165-.199.053-50.574-13.656-3.233-36.217h-24.575-21.01l6.362 71.301 93.02 25.823z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2999_00000183935336956994173500000009856227378309738643_",
    d: "m160 0h55v23h-32v23h32v23h-55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3001_00000096055226761582317920000005110122629658984122_",
    d: "m226 0h55v20h-32v4h32v46h-55v-21h32v-4h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3003_00000136402835624896882680000006132478931596835508_",
    d: "m292 0h55v20h-32v4h32v46h-55v-21h32v-4h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3005_00000173137955367200700520000015002477665718237887_",
    d: "m311.761 313.627-5.271 58.894-50.647 13.67v47.244l93.094-25.801.683-7.672 10.671-119.551 1.108-12.194 8.198-91.912h-113.754v45.411h63.988l-4.132 46.501h-59.856v45.41z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss);
export default __webpack_public_path__ + "static/media/icon_css.17f4952a7c3e70ea74b2de6dbf61db61.svg";
export { ForwardRef as ReactComponent };